import React, { useEffect, useRef, useState } from 'react'
import API_ENDPOINTS from '../../helperFunction/Constant'
import ApiHelper from '../../helperFunction/ApiHelper'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import Layout from '../common/Layout'
import { Toast } from 'primereact/toast'
import { confirmDialog, ConfirmDialog } from 'primereact/confirmdialog'
import { Column } from 'primereact/column'
import { DataTable } from 'primereact/datatable'
import { Rating } from 'primereact/rating'
import { IconField } from 'primereact/iconfield'
import { InputIcon } from 'primereact/inputicon'
import { InputText } from 'primereact/inputtext'

const Courses = () => {

    const toast = useRef(null)
    const [globalFilterValue, setGlobalFilterValue] = useState('');

    const location = useLocation();

    const [categoryData, setCategoryData] = useState([])
    const [courses, setCourses] = useState([])

    const [selectedCategoryId, setSelectedCategoryId] = useState(location.state?.categoryId || null);

    const navigate = useNavigate()

    useEffect(() => {
        getCourses()
        getCategoryData()
    }, [])

    useEffect(() => {
        if (location.state?.categoryId) {
            setSelectedCategoryId(location.state.categoryId);
            navigate(location.pathname, { replace: true, state: null });
        }
    }, []);

    const getCategoryData = () => {
        ApiHelper.get(`${API_ENDPOINTS.CATEGORY}?active=true`).then((res) => {
            if (res.status === 200) {
                setCategoryData(res.data.data)
            }
        }).catch((error) => {
            console.log("Error: ", error);
        })
    }

    const getCourses = () => {
        ApiHelper.get(API_ENDPOINTS.COURSES).then((res) => {
            if (res.status === 200) {
                setCourses(res.data.data)
            }
        }).catch((error) => {
            console.log("Error: ", error);
        })
    }

    const serialNoTemplate = (rowData, options) => { return options.rowIndex + 1; };

    const imageBodyTemplate = (rowData) => {
        return (
            rowData?.courseImage ? (
                <div style={{ display: "flex", alignItems: "center", gap: "10px", color: 'blue', cursor: 'pointer' }} onClick={() => navigate(`/courses/edit/${rowData.courseId}`)} >
                    <img
                        src={`${process.env.REACT_APP_BASE_URL}/${rowData?.courseImage}`}
                        alt=""
                        style={{ width: 'auto', height: '50px', objectFit: 'cover' }}
                        onError={(e) => {
                            e.target.src = "/img/placeholder-image.jpg"
                        }}
                    />
                    {rowData?.courseName}
                </div>
            ) : null
        );
    };

    // const contentBodyTemplate = (rowData) => {
    //     return (
    //         rowData?.courseImage ? (
    //             <div style={{ display: "block", alignItems: "center", justifyContent: 'center', textAlign: 'center' }}>
    //                 <small>{rowData?.sectionCount || 0} sections | {rowData?.videoCount || 0} videos | {rowData?.courseDuration || '-'}</small>
    //             </div>
    //         ) : null
    //     );
    // };

    const statusBodyTemplate = (rowData) => {
        return (
            <span className={`badge ${rowData.isActive ? 'bg-success' : 'bg-danger'}`}>
                {rowData.isActive ? 'Active' : 'Inactive'}
            </span>
        );
    };

    const actionBodyTemplate = (rowData) => {
        return (
            <>
                <button onClick={() => navigate(`/courses/edit/${rowData.courseId}`)} className="btn btn-primary btn-sm me-2"> <i class="bi bi-pencil-square"></i> </button>
                <button onClick={() => confirmDeleteDailog(rowData.courseId)} className="btn btn-danger btn-sm"> <i class="bi bi-trash"></i> </button>
            </>
        );
    };

    const priceAndMrpBodyTemplate = (rowData) => {
        return (
            <>
                <p className="m-0"> ₹{rowData.coursePrice} <small><strike>₹{rowData.courseMrp}</strike></small></p>
            </>
        );
    };

    const confirmDeleteDailog = (id) => {
        confirmDialog({
            message: 'Do you want to delete this record?',
            header: 'Delete Confirmation',
            icon: 'pi pi-info-circle',
            defaultFocus: null,
            acceptClassName: 'p-button-danger',
            accept: () => deleteCourse(id),
        });
    };

    const deleteCourse = (id) => {
        ApiHelper.delete(`${API_ENDPOINTS.COURSES}/${id}`).then((res) => {
            if (res.status === 200) {
                toast.current.show({ severity: 'success', summary: 'Success', detail: res.data.message, life: 3000 })
                getCourses()
            }
        }).catch((error) => {
            console.log("Error: ", error);
        })
    }

    const renderHeader = () => {
        return (
            <div className="flex justify-content-end">
                <IconField iconPosition="left">
                    <InputIcon className="pi pi-search" />
                    <InputText value={globalFilterValue} onChange={(e) => setGlobalFilterValue(e.target.value)} placeholder="Search" />
                </IconField>
            </div>
        );
    };

    const filteredCourses = selectedCategoryId ? courses.filter(item => item.categoryId === Number(selectedCategoryId)) : courses;

    return (
        <>
            <Toast ref={toast} />
            <ConfirmDialog />
            <Layout>
                <div class="content-wrapper">
                    <div class="container-xxl flex-grow-1 container-p-y">
                        <div class="d-flex justify-content-between align-items-center py-3">
                            <h4 class="fw-bold py-3 mb-2"><span class="text-muted fw-light"> <p className="breadcrumb-item active mb-0" aria-current="page">Courses</p></span></h4>
                            <div className='d-flex'>
                                <div className='mx-3'>
                                    <Link class="btn btn-primary" to={'/courses/add'} >Add New Course</Link>
                                </div>
                                <div>
                                    <select id="mySelect" value={selectedCategoryId} onChange={(e) => setSelectedCategoryId(e.target.value)} class="form-select" >
                                        <option value="">Select Category</option>
                                        {categoryData.map((item) => (
                                            <option value={item.categoryId}>{item.categoryName}</option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="card mb-4">
                                    <div class="card-body">
                                        <DataTable globalFilter={globalFilterValue} header={renderHeader} paginator rows={50} rowsPerPageOptions={[50, 100, 150, 200]} showGridlines size="small" value={filteredCourses} tableStyle={{ minWidth: '50rem' }} >
                                            <Column body={serialNoTemplate} header='S.NO' />
                                            <Column sortable header='Name' body={imageBodyTemplate} field='courseName' />
                                            <Column sortable header='Category' field='category' />
                                            <Column sortable header='Price' body={priceAndMrpBodyTemplate} field='coursePrice' />
                                            <Column sortable header='Status' body={statusBodyTemplate} />
                                            <Column sortable header='Action' body={actionBodyTemplate} />
                                        </DataTable>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Layout>
        </>
    )
}

export default Courses
